import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#111111] text-[#FAFAF7] pt-12 pb-20 overflow-hidden" data-id="element-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-52">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left z-10" data-id="element-53">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E8652D]/10 border border-[#E8652D]/20 text-[#E8652D] text-sm font-semibold mb-6" data-id="element-54">
              <span className="relative flex h-2 w-2" data-id="element-55">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E8652D] opacity-75" data-id="element-56"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#E8652D]" data-id="element-57"></span>
              </span>
              Descarga inmediata · $6.39 USD
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.1] mb-6" data-id="element-58">
              Baja grasa{' '}
              <span className="text-[#E8652D]" data-id="element-59">sin contar nada.</span>
            </h1>

            <p className="text-xl sm:text-2xl text-gray-300 mb-8 font-medium leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-60">
              Plan de comidas en 10 minutos. Vida real.
              <br data-id="element-61" />
              <span className="text-gray-400 text-lg font-normal" data-id="element-62">
                Sin dietas rígidas. Sin pasar hambre.
              </span>
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-63">
              <Button size="xl" className="w-full sm:w-auto text-lg shadow-[#E8652D]/25 shadow-xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-64">
                Quiero el plan por $6.39
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-65" />
              </Button>
            </div>

            <div className="mt-8 flex flex-wrap justify-center lg:justify-start gap-4 text-sm text-gray-400" data-id="element-66">
              <div className="flex items-center gap-1.5" data-id="element-67">
                <CheckIcon className="h-4 w-4 text-[#E8652D]" data-id="element-68" />
                <span data-id="element-69">Acceso de por vida</span>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative w-full max-w-[600px] lg:max-w-none" data-id="element-70">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-white/10" data-id="element-71">
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/80 via-transparent to-transparent z-10 lg:hidden" data-id="element-72"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9oGjJc8aCtgZfJxJfyqXut/Foto_Cover_Producto_2.png" alt="Meal Prep Turbo Cover" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-73" />
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1,
            duration: 0.5
          }} className="absolute -bottom-6 -right-6 bg-[#FAFAF7] text-[#111111] p-4 rounded-xl shadow-xl border border-gray-200 hidden md:block z-20" data-id="element-74">
              <div className="flex items-center gap-3" data-id="element-75">
                <div className="bg-[#E8652D] text-white font-bold px-2 py-1 rounded text-sm" data-id="element-76">
                  NUEVO
                </div>
                <div className="text-sm font-semibold" data-id="element-77">Edición 2024</div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}